import './Application.scss';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/tiptap/styles.css';
import 'mantine-react-table/styles.css';
import 'mantine-contextmenu/styles.css';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';

import { CSSVariablesResolver, MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ContextMenuProvider } from 'mantine-contextmenu';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, storePersister } from '../../store';
import { UnauthenticatedAppJWT } from '../application/UnauthenticatedAppJWT';
import { UnauthenticatedAppOIDC } from '../application/UnauthenticatedAppOIDC';
import { AuthProvider } from '../authentication/AuthProvider';
import { mantineTheme } from '../mantineTheme';
import { LoadingComponent } from '../reusable-components/LoadingComponent';
import { AuthenticatedApp } from '../router/router';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 5000,
            refetchInterval: 15000,
            retry: false,
        },
    },
});

const resolver: CSSVariablesResolver = () => ({
    variables: {
        '--mantine-color-warning': '#ff9800',
        '--mantine-color-info': '#2196f3',
    },
    light: {
        '--mantine-text-secondary-color': 'rgba(0, 0, 0, 0.8)',
        '--mantine-text-reverse-secondary-color': 'rgba(255, 255, 255, 0.8)',
        '--mantine-color-base-button': '#141414',
        '--mantine-color-read-only-input': '#f1f3f5',
        '--mantine-color-grammar-rule-editor-background': 'white',
    },
    dark: {
        '--mantine-color-read-only-input': '#495057',
        '--mantine-color-base-button': '#F8F9FA',
        '--mantine-text-secondary-color': 'rgba(255, 255, 255, 0.8)',
        '--mantine-text-reverse-secondary-color': 'rgba(0, 0, 0, 0.8)',
        '--mantine-color-grammar-rule-editor-background': '#2e2e2e',
    },
});

export const Application = () => {
    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={storePersister}>
                <MantineProvider theme={mantineTheme} defaultColorScheme={'light'} cssVariablesResolver={resolver}>
                    <Notifications position={'bottom-left'} zIndex={3000} notificationMaxHeight={40} />
                    <ContextMenuProvider>
                        <QueryClientProvider client={queryClient}>
                            <AuthProvider
                                loading={<LoadingComponent open={true} />}
                                UnauthenticatedAppJWT={UnauthenticatedAppJWT}
                                UnauthenticatedAppOIDC={UnauthenticatedAppOIDC}
                            >
                                <AuthenticatedApp />
                            </AuthProvider>
                        </QueryClientProvider>
                    </ContextMenuProvider>
                </MantineProvider>
            </PersistGate>
        </Provider>
    );
};
